import Button from './button'
import { Modal } from 'ant-design-vue'

Button.install = (Vue) => {
  Vue.component(Button.name, Button)
  Vue.use(Modal)
}

export default Button
